import useFeatureFlags from 'hooks/useFeatureFlags'
import React from 'react'

/**
 * Higher-Order Component that provides feature flags as props to wrapped components
 *
 * @param {React.Component} WrappedComponent - The component to wrap
 * @returns {React.Component} - Component with feature flags injected as props
 *
 * Usage:
 * export default withFeatureFlags(connect(mapStateToProps, mapDispatchToProps)(MyComponent))
 *
 * The wrapped component will receive:
 * - flags: object containing all feature flags
 * - featureFlagMethods: object containing LaunchDarkly methods (like identify)
 */

const withFeatureFlags = (WrappedComponent) => {
  const WithFeatureFlagsComponent = (props) => {
    const { flags, methods } = useFeatureFlags()

    return <WrappedComponent {...props} flags={flags} featureFlagMethods={methods} />
  }

  return WithFeatureFlagsComponent
}

export default withFeatureFlags
